export default [
    {
        id: 'S',
        label: 'Short',
    },
    {
        id: 'L',
        label: 'Long',
    },
    {
        id: 'A',
        label: 'Arc',
    },
];
